import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class AgenceService {

  constructor(private http:HttpClient,private global:Global) { }
  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };
  getHistoriques(url){
    return this.http.get(url +"/_api/web/lists/GetByTitle('Historique')/items?"
        +"$select=*",this.httpOptions);
  }
  getRapport(url){
    return this.http.get(url +"/_api/web/lists/GetByTitle('RapportsAnnuels')/items?"
        +"$select=*,File/ServerRelativeUrl&$expand=File",this.httpOptions);
  }
  urlAgence = this.global._Url + '/Agence/'
  getMenuData(){
    return this.http.get(this.urlAgence +"_api/web/lists/GetByTitle('Menu')/items?"
      +"$select=*,AttachmentFiles&$filter=MenuPrincipal eq 1&$expand=AttachmentFiles&$top=1000",this.httpOptions);
  }
  getMenuPageData(codePage , lg) {
    const url =this.urlAgence  + lg +"/_api/web/lists/GetByTitle('PageStatique')/items?"
    +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File&$filter=MenuUrl eq '" + codePage +"'"
  return this.http.get(url ,this.httpOptions);
}
}
